"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SYMBOL_ORIGIN = exports.SYMBOL_DATA_PROVIDER = exports.NetworkStatus = exports.FetchPolicy = void 0;

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var SYMBOL_DATA_PROVIDER = Symbol('clay.data.provider');
exports.SYMBOL_DATA_PROVIDER = SYMBOL_DATA_PROVIDER;
var SYMBOL_ORIGIN = Symbol('clay.internal');
/**
 * - Loading (1) The status is set to `loading` only when the first
 *   requisition occurs.
 * - Refetch (2) The status is set to `refetch` when a change in the variables API
 *   or refetch method is called.
 * - Polling (3) The status is set to `polling` when pollInterval is set above 0.
 * - Unused (4) When no request is happening the status will be `unused`.
 * - Error (5) When any timeout or request `error` occurs, the status will be set
 *   to error.
 */

exports.SYMBOL_ORIGIN = SYMBOL_ORIGIN;
var NetworkStatus;
exports.NetworkStatus = NetworkStatus;

(function (NetworkStatus) {
  NetworkStatus[NetworkStatus["Error"] = 5] = "Error";
  NetworkStatus[NetworkStatus["Loading"] = 1] = "Loading";
  NetworkStatus[NetworkStatus["Polling"] = 3] = "Polling";
  NetworkStatus[NetworkStatus["Refetch"] = 2] = "Refetch";
  NetworkStatus[NetworkStatus["Unused"] = 4] = "Unused";
})(NetworkStatus || (exports.NetworkStatus = NetworkStatus = {}));

var FetchPolicy;
exports.FetchPolicy = FetchPolicy;

(function (FetchPolicy) {
  FetchPolicy["CacheFirst"] = "cache-first";
  FetchPolicy["NoCache"] = "no-cache";
  FetchPolicy["CacheAndNetwork"] = "cache-and-network";
})(FetchPolicy || (exports.FetchPolicy = FetchPolicy = {}));